import { Link } from 'react-router-dom';

const linkClass =
  'text-th-primary transition-colors underline-offset-2 hover:underline hover:opacity-90';

/**
 * Single-row footer: copyright and legal / about links.
 */
export function SiteFooter() {
  return (
    <footer
      className="relative z-[5] shrink-0 border-t border-subtle/60 bg-surface/80 px-4 py-2.5 text-center text-[11px] text-th-primary backdrop-blur-sm sm:text-xs"
      role="contentinfo"
    >
      <div className="mx-auto flex max-w-6xl flex-col items-center justify-center gap-1.5 sm:flex-row sm:flex-wrap sm:gap-x-2 sm:gap-y-1">
        <span>© {new Date().getFullYear()} San Juniper</span>
        <span className="hidden sm:inline opacity-70" aria-hidden>
          ·
        </span>
        <nav
          className="flex flex-wrap items-center justify-center gap-x-2.5 gap-y-0.5 sm:gap-x-3"
          aria-label="Legal and about"
        >
          <Link to="/appTOS?tab=terms" className={linkClass}>
            Terms of Service
          </Link>
          <span className="opacity-70" aria-hidden>
            ·
          </span>
          <Link to="/appTOS?tab=privacy" className={linkClass}>
            Privacy Policy
          </Link>
          <span className="opacity-70" aria-hidden>
            ·
          </span>
          <Link to="/about" className={linkClass}>
            About Hyper App Store
          </Link>
        </nav>
      </div>
    </footer>
  );
}
